import { tokens, WHITE } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getOfferStripWidgetStyles = props => {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'under-card' : _props$variant;
  var isUnderCard = variant === 'under-card';
  var borderRadius32 = tokens.borderRadius.BORDER_RADIUS_32;
  var cardBorderRadius = {
    borderBottomLeftRadius: tokens.borderRadius.BORDER_RADIUS_15,
    borderBottomRightRadius: tokens.borderRadius.BORDER_RADIUS_15
  };
  return StyleSheet.create({
    container: {
      padding: tokens.spacing.SPACING_1,
      borderRadius: borderRadius32
    },
    innerContainer: Object.assign(Object.assign({
      width: 'auto',
      paddingHorizontal: tokens.spacing.SPACING_12,
      paddingVertical: tokens.spacing.SPACING_8
    }, isUnderCard ? {
      borderRadius: borderRadius32
    } : Object.assign(Object.assign({}, cardBorderRadius), {
      borderWidth: 1,
      borderColor: WHITE
    })), {
      flexDirection: 'row',
      alignItems: 'center'
    }),
    text: {
      marginLeft: tokens.spacing.SPACING_8,
      flex: 1
    },
    iconContainer: {
      position: 'relative'
    },
    offerIcon: {
      position: 'absolute',
      left: tokens.spacing.SPACING_7,
      top: tokens.spacing.SPACING_7
    }
  });
};